"use client"

import { Heading6 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Heading6Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Heading6Icon = component(Icon)({ as: Heading6 })
